import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { ConversionFunnel } from '../../lib/types';

interface FunnelChartProps {
  data: ConversionFunnel;
  className?: string;
}

export function FunnelChart({ data, className = '' }: FunnelChartProps) {
  const chartData = [
    { name: 'Footfall', value: data.footfall, color: '#3B82F6' },
    { name: 'Interaction', value: data.interaction, color: '#10B981' },
    { name: 'Conversion', value: data.conversion, color: '#F59E0B' }
  ];

  const formatTooltip = (value: number, name: string, props: any) => {
    const index = props.payload.name;
    if (index === 'Interaction') {
      return [`${value.toLocaleString()} (${data.interactionRate.toFixed(1)}%)`, 'Interactions'];
    } else if (index === 'Conversion') {
      return [`${value.toLocaleString()} (${data.conversionRate.toFixed(1)}%)`, 'Conversions'];
    }
    return [value.toLocaleString(), index];
  };

  return (
    <div className={`bg-white p-6 rounded-lg shadow ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Sales Funnel</h3>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} layout="horizontal">
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              type="number"
              tick={{ fontSize: 12 }}
              tickFormatter={(value) => value.toLocaleString()}
            />
            <YAxis 
              type="category" 
              dataKey="name"
              tick={{ fontSize: 12 }}
            />
            <Tooltip formatter={formatTooltip} />
            <Bar dataKey="value" radius={[0, 4, 4, 0]}>
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 flex justify-center space-x-6 text-sm">
        <span className="text-blue-600">
          Footfall: {data.footfall.toLocaleString()}
        </span>
        <span className="text-green-600">
          Interaction Rate: {data.interactionRate.toFixed(1)}%
        </span>
        <span className="text-amber-600">
          Conversion Rate: {data.conversionRate.toFixed(1)}%
        </span>
      </div>
    </div>
  );
}
